import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import {
  Button,
  Divider,
  Icon,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { AuthRepository } from "../repositories/AuthRepository";

export const SideMenuLinks = [
  {
    name: "ASTA ADRIA",
    path: "/",
    roles: ["ROLE_CLIENT"],
  },
  // {
  //   name: "Dashboard",
  //   path: `/`,
  //   selectedPath: "/",
  //   icon: <DashboardOutlinedIcon sx={{ fontSize: "20px" }} />,
  //   roles: ["ROLE_CLIENT"],
  // },
  {
    name: "Booking",
    path: `/client/bookings/0/15/${JSON.stringify({
      status: "ALL_ACTIVE",
    })}/dateCreated/DESC`,
    selectedPath: "/client/booking",

    icon: <ConfirmationNumberOutlinedIcon sx={{ fontSize: "20px" }} />,
    roles: ["ROLE_CLIENT"],
  },
  {
    name: "Create New Booking",
    path: "/client/newBooking",
    selectedPath: "/client/newBooking",
    icon: "add_circle_outline",
    roles: ["ROLE_CLIENT"],
  },
  {
    name: "Upload Bookings",
    path: `/client/uploads/0/15/${JSON.stringify({})}/dateCreated/DESC`,
    selectedPath: "/client/uploads",
    icon: "file_upload_outlined",
    roles: ["ROLE_CLIENT"],
  },
  {
    name: "Declarations",
    path: `/client/consignment/0/15/${JSON.stringify({
      status: "ALL",
    })}/dateCreated/DESC`,
    selectedPath: "/client/consignment",
    icon: "article",
    roles: ["ROLE_CLIENT"],
  },
  {
    name: "GVMS",
    path: `/gvms`,
    selectedPath: `/gvms`,
    icon: "departure_board",
    roles: ["ROLE_CLIENT"]
  },
  {
    name: "ELO",
    path: `/eloMessage/0/15/${JSON.stringify({})}/dateCreated/DESC`,
    selectedPath: "/eloMessage",
    icon: "drafts",
    roles: ["ROLE_CLIENT"]
  },
];

export const SideMenuLinksDown = [
  {
    name: "Profile",
    roles: ["ROLE_CLIENT"],
  },
  {
    name: "Logout",
    path: "/login",
    selectedPath: "/login",
    icon: "logout",
    roles: ["ROLE_CLIENT"],
  },
];

export const SideMenuLinksMobile = [
  // {
  //   name: "Dashboard",
  //   path: `/`,
  //   selectedPath: "/",
  //   icon: (
  //     <svg
  //       width="27"
  //       height="27"
  //       viewBox="0 0 36 36"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         d="M19.5 13.5V4.50003H31.5V13.5H19.5ZM4.5 19.5V4.50003H16.5V19.5H4.5ZM19.5 31.5V16.5H31.5V31.5H19.5ZM4.5 31.5V22.5H16.5V31.5H4.5ZM7.5 16.5H13.5V7.50003H7.5V16.5ZM22.5 28.5H28.5V19.5H22.5V28.5ZM22.5 10.5H28.5V7.50003H22.5V10.5ZM7.5 28.5H13.5V25.5H7.5V28.5Z"
  //         fill="white"
  //         style={{ fill: "white", fillOpacity: 1 }}
  //       />
  //     </svg>
  //   ),
  //   roles: ["ROLE_CLIENT"],
  // },
  {
    name: "Booking",
    path: `/client/bookings/0/15/${JSON.stringify({
      status: "ALL_ACTIVE",
    })}/dateCreated/DESC`,
    selectedPath: "/client/booking",

    icon: (
      <svg
        width="27"
        height="27"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 25.5001C18.425 25.5001 18.7813 25.3564 19.0688 25.0689C19.3563 24.7814 19.5 24.4251 19.5 24.0001C19.5 23.5751 19.3563 23.2189 19.0688 22.9314C18.7813 22.6439 18.425 22.5001 18 22.5001C17.575 22.5001 17.2188 22.6439 16.9313 22.9314C16.6438 23.2189 16.5 23.5751 16.5 24.0001C16.5 24.4251 16.6438 24.7814 16.9313 25.0689C17.2188 25.3564 17.575 25.5001 18 25.5001ZM18 19.5001C18.425 19.5001 18.7813 19.3564 19.0688 19.0689C19.3563 18.7814 19.5 18.4251 19.5 18.0001C19.5 17.5751 19.3563 17.2189 19.0688 16.9314C18.7813 16.6439 18.425 16.5001 18 16.5001C17.575 16.5001 17.2188 16.6439 16.9313 16.9314C16.6438 17.2189 16.5 17.5751 16.5 18.0001C16.5 18.4251 16.6438 18.7814 16.9313 19.0689C17.2188 19.3564 17.575 19.5001 18 19.5001ZM18 13.5001C18.425 13.5001 18.7813 13.3564 19.0688 13.0689C19.3563 12.7814 19.5 12.4251 19.5 12.0001C19.5 11.5751 19.3563 11.2189 19.0688 10.9314C18.7813 10.6439 18.425 10.5001 18 10.5001C17.575 10.5001 17.2188 10.6439 16.9313 10.9314C16.6438 11.2189 16.5 11.5751 16.5 12.0001C16.5 12.4251 16.6438 12.7814 16.9313 13.0689C17.2188 13.3564 17.575 13.5001 18 13.5001ZM30 30.0001H6C5.175 30.0001 4.46875 29.7064 3.88125 29.1189C3.29375 28.5314 3 27.8251 3 27.0001V21.0001C3.825 21.0001 4.53125 20.7064 5.11875 20.1189C5.70625 19.5314 6 18.8251 6 18.0001C6 17.1751 5.70625 16.4689 5.11875 15.8814C4.53125 15.2939 3.825 15.0001 3 15.0001V9.00012C3 8.17512 3.29375 7.46887 3.88125 6.88137C4.46875 6.29387 5.175 6.00012 6 6.00012H30C30.825 6.00012 31.5313 6.29387 32.1188 6.88137C32.7063 7.46887 33 8.17512 33 9.00012V15.0001C32.175 15.0001 31.4688 15.2939 30.8813 15.8814C30.2938 16.4689 30 17.1751 30 18.0001C30 18.8251 30.2938 19.5314 30.8813 20.1189C31.4688 20.7064 32.175 21.0001 33 21.0001V27.0001C33 27.8251 32.7063 28.5314 32.1188 29.1189C31.5313 29.7064 30.825 30.0001 30 30.0001ZM30 27.0001V23.1751C29.075 22.6251 28.3438 21.8939 27.8063 20.9814C27.2688 20.0689 27 19.0751 27 18.0001C27 16.9251 27.2688 15.9314 27.8063 15.0189C28.3438 14.1064 29.075 13.3751 30 12.8251V9.00012H6V12.8251C6.925 13.3751 7.65625 14.1064 8.19375 15.0189C8.73125 15.9314 9 16.9251 9 18.0001C9 19.0751 8.73125 20.0689 8.19375 20.9814C7.65625 21.8939 6.925 22.6251 6 23.1751V27.0001H30Z"
          fill="white"
          style={{ fill: "white", fillOpacity: 1 }}
        />
      </svg>
    ),
    roles: ["ROLE_CLIENT"],
  },
  {
    name: "Upload Bookings",
    path: `/client/uploads/0/15/${JSON.stringify({})}/dateCreated/DESC`,
    selectedPath: "/client/uploads",
    icon: "file_upload_outlined",
    roles: ["ROLE_CLIENT"],
  },
  {
    name: "Declarations",
    path: `/client/consignment/0/15/${JSON.stringify({
      status: "ALL",
    })}/dateCreated/DESC`,
    selectedPath: "/client/consignment",
    icon: "article",
    roles: ["ROLE_CLIENT"],
  },
  {
    name: "GVMS",
    path: `/gvms`,
    selectedPath: `/gvms`,
    icon: "departure_board",
    roles: ["ROLE_CLIENT"]
  },
  {
    name: "ELO",
    path: `/eloMessage/0/15/${JSON.stringify({})}/dateCreated/DESC`,
    selectedPath: "/eloMessage",
    icon: "drafts",
    roles: ["ROLE_CLIENT"]
  },
];


export const CreateNewBookingListMobile = [
  {
    name: "Create New Booking",
    path: "/client/newBooking",
    selectedPath: "/client/newBooking",
    icon: "add_circle_outline",
    roles: ["ROLE_CLIENT"],
  },
];

export const ProfileListMobile = [
  {
    name: "Profile",
    roles: ["ROLE_CLIENT"],
  },
];

export const LogoutListMobile = [
  {
    name: "Logout",
    path: "/login",
    selectedPath: "/login",
    icon: "logout",
    roles: ["ROLE_CLIENT"],
  },
];
